module.exports = __webpack_public_path__ + "img/page.0f00b2ea.png";